<template>
  <div class="d-flex align-center" style="height: 50px">
    <div class="d-flex justify-space-between" style="width: 250px">
      <div style="width: 120px">{{ kind === 'cen' ? 'Học phí:' : 'Thu hộ / chi hộ:' }}</div>
      <div class="d-flex">
        <div class="text-right">
          {{ item[kind].amountPaid | price }}
        </div>
        <div class="ml-4">
          <v-icon color="#46BE8A" v-if="item[kind].isPaid">mdi-checkbox-marked-circle</v-icon>
          <v-icon color="#F4BB43" v-else>mdi-cancel</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    kind: String,
    item: Object
  }
}
</script>

<style lang="scss" scoped>
.text-right {
  text-align: right;
  min-width: 70px;
}
</style>
